/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasectioncontract3Inputs */

const en_casedatasectioncontract3 = /** @type {(inputs: Casedatasectioncontract3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The contract`)
};

const pt_casedatasectioncontract3 = /** @type {(inputs: Casedatasectioncontract3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O contrato`)
};

/**
* | output |
* | --- |
* | "The contract" |
*
* @param {Casedatasectioncontract3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasectioncontract3 = /** @type {((inputs?: Casedatasectioncontract3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasectioncontract3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasectioncontract3(inputs)
	return pt_casedatasectioncontract3(inputs)
});
export { casedatasectioncontract3 as "caseDataSectionContract" }